import { get as _get } from 'lodash';
import { prettifySize } from 'utils/prettify';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '4',
    active: false,
    col: 'select-btn',
    cssWidth: '50px',
  },
  {
    title: '',
    sortable: false,
    col: 'photo',
    link: true,
    type: 'image',
    cssWidth: '65px',
  },
  {
    title: 'File type',
    sortable: true,
    sortName: 'fileType',
    sort: 'desc',
    active: false,
    col: 'file_type',
    cssWidth: '95px',
  },
  {
    title: 'File name',
    sortable: true,
    sortName: 'fileName',
    sort: 'desc',
    link: true,
    active: false,
    col: 'filename',
  },
  {
    title: 'Uploaded',
    sortable: true,
    sortName: 'uploadedAt',
    sort: 'desc',
    active: false,
    type: 'date',
    col: 'uploaded_at',
    cssWidth: '160px',
  },
  {
    title: 'Dimensions',
    sortable: false,
    col: 'dimensions',
    data: (row: any) => {
      const width = _get(row, 'width');
      const height = _get(row, 'height');
      const uom = _get(row, 'uom');
      if (!width && !height && !uom) {
        return undefined;
      }
      return `${width} x ${height}${uom}`;
    },
    cssWidth: '160px',
  },
  {
    title: 'File size',
    sortable: true,
    sort: 'desc',
    sortName: 'fileSize',
    align: 'right',
    active: false,
    col: 'filesize',
    data: (row: any) => {
      const filesize = _get(row, 'filesize');
      return prettifySize(filesize);
    },
    cssWidth: '95px',
  },
];
